import { gql } from '@apollo/client';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { Query } from '@mfe/shared/schema-types';

import { graphqlQuery } from '../graphql';
import {
  ConfigState,
  fetchConfig as fetchConfigAction,
  getMaintenanceStatus as getMaintenanceStatusAction,
  setConfig,
} from './slice';

const GET_CONFIG = gql`
  query getConfig {
    config {
      analyticsUrl
      env
      vppUrl
      aemBaseUrl
      aemContentBaseUrl

      ...FeatureFlags
    }
  }

  fragment FeatureFlags on ConfidantConfig {
    inMaintenance
    getMockTier
    enableFiber
    disconnectRegions
    sendSurveyToSalesforce
    showEasyCareDisclaimers
    isPreauthZeroEnabled
    enableBridgeMode
    unrestrictedRemovalProducts
    restrictAddonRemoval
    enableUnleashedMaxTier
  }
`;

const GET_MAINTENANCE_STATUS = gql`
  query getMaintenanceStatus {
    getMaintenanceStatus {
      inMaintenance
    }
  }
`;

export function* fetchConfig() {
  const data: Query = yield call(graphqlQuery, {
    query: GET_CONFIG,
  });

  yield put(setConfig({ ...data.config, loadingConfig: false }));
}

export function* getMaintenance() {
  const data: Query = yield call(graphqlQuery, {
    query: GET_MAINTENANCE_STATUS,
  });

  yield put(
    setConfig({
      inMaintenance: data.getMaintenanceStatus.inMaintenance,
    } as ConfigState)
  );
}

export function* watchConfig() {
  yield all([
    takeLatest(fetchConfigAction.type, fetchConfig),
    takeLatest(getMaintenanceStatusAction.type, getMaintenance),
  ]);
}
